// https://www.apollographql.com/docs/react/data/queries/#supported-fetch-policies

export const CACHE_AND_NETWORK = 'cache-and-network'
export const CACHE_FIRST = 'cache-first'
export const CACHE_ONLY = 'cache-only'
export const NETWORK_ONLY = 'network-only'
export const NO_CACHE = 'no-cache'
export const STANDBY = 'standby'
